import type { AdminRole } from '@/lib/api-admin';

/** SUPER_ADMIN/OPS_ADMIN/AUDITOR may read admin account & role pages. */
export const ADMIN_READ_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'OPS_ADMIN', 'AUDITOR'];

/** Only SUPER_ADMIN may create/update/replace-roles/deactivate admins. */
export const ADMIN_WRITE_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN'];
